import { ScrollTop } from '@/components/element/ScrollTop';
import { QuotationTaskEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficeQuotationTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { quotationTask: task } = useCurrentQuotationTask();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('見積申請タスク編集'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `見積申請タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/quotation_tasks` },
        {
          label: `見積申請タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${sales_order_id}/quotation_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskEditForm />
    </WorkspaceLayout>
  );
};
